import React, { useEffect, useMemo, useState } from "react";
import { Select, Space, Typography } from 'antd';
import { useOrderSearchForTicket } from 'modules/CreateTicket/store';
import { filterOption } from 'modules/utilities/utility';
import _ from 'lodash';

function SubCategoryFilter({ selectedCategory, selectedSubCategory, setSelectedSubCategory, }) {
  const { allCrmCategories, fetchCrmCategories } = useOrderSearchForTicket();
  const [subcats, setSubcats] = useState([])
  const subCategoryOptions = useMemo(() => {
    if (selectedCategory && !_.isEmpty(selectedCategory)) {
      const option = allCrmCategories.filter(category => selectedCategory.includes(category.value)).map(category => category.subcategory);
      return option.flat();
    }
    const option = allCrmCategories.map(category => category.subcategory);
    return option.flat();

  }, [selectedCategory])

  function handleSelect(data) {
    setSelectedSubCategory(data);
  }
  useEffect(()=>{ if(_.isEmpty(allCrmCategories)){fetchCrmCategories()}}, [])
  useEffect(()=>{ if(_.isEmpty(subCategoryOptions)){setSubcats(allCrmCategories.map(category => category.subcategory).flat())}},[allCrmCategories])

  return (
    <>
      <Space.Compact block className='my-2'>
        <span style={{ background: '#FAFAFA', border: '#D9D9D9', width: '30%' }} className='border border-1 border-end-0 d-flex justify-conent-center align-items-center rounded-lg rounded-start px-2'>
          <Typography.Text>Select Subcategory</Typography.Text>
        </span>
        <Select
          mode='multiple'
          style={{ width: '70%' }}
          showSearch
          allowClear
          placeholder='Subategory'
          optionFilterProp='children'
          value={selectedSubCategory}
          onChange={handleSelect}
          filterOption={filterOption}
          options={_.isEmpty(subCategoryOptions)? subcats : subCategoryOptions}
        />
      </Space.Compact>
    </>
  );
}

export default SubCategoryFilter;
